const store = {};

/**
 * Retreives a value from the noObserve store.
 *
 * @param {String} owner
 * @param {String} name
 * @returns {any}
 */
function get(owner, name) {
  return store[`${owner}_${name}`];
}

/**
 * Removes a value from the noObserve store.
 * - will also remove the key
 *
 * @param {String} owner
 * @param {String} name
 */
function remove(owner, name) {
  delete store[`${owner}_${name}`];
}

/**
 * Sets a value in the noObserve store by owner + name.
 *
 * @param {String} owner
 * @param {String} name
 * @param {any} value
 */
function set(owner, name, value) {
  store[`${owner}_${name}`] = value;
}

const exported = {
  get,
  remove,
  set,
  // eslint-disable-next-line no-underscore-dangle
  _store: store, // only here for testing purposes
};

export default exported;
